import $ from "jquery";

export default class NewsletterForm {
    constructor() {
        this.form = document.getElementById('newsletter-form');

        if (this.form) {
            this.initElements();
            this.initEventListeners();
        }
    }

    initElements() {
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.originalButtonText = this.submitButton.textContent;
        this.messageContainer = this.form.querySelector('.form-messages');
        this.formFieldsWrapper = this.form.querySelector('.form-fields-wrapper');
    }

    initEventListeners() {
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    handleSubmit(e) {
        e.preventDefault();

        const emailInput = this.form.querySelector('input[name="email"]');
        const email = emailInput.value.trim();
        const privacyCheckbox = this.form.querySelector('input[name="privacy"]');

        // Clear previous messages
        this.clearMessages();

        // Validate email
        if (!this.isValidEmail(email)) {
            this.showError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
            emailInput.focus();
            return;
        }

        // Validate privacy checkbox
        if (!privacyCheckbox.checked) {
            this.showError('Bitte akzeptieren Sie die Datenschutzbestimmungen.');
            return;
        }

        // Show loading state
        this.setLoadingState(true);

        const formData = new FormData(this.form);

        // Submit via AJAX
        fetch(this.form.action, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => this.handleResponse(data))
        .catch(error => this.handleError(error));
    }

    handleResponse(data) {
        this.setLoadingState(false);

        // Check for validation errors
        if (data.errors && Object.keys(data.errors).length > 0) {
            const errorMessages = Object.values(data.errors).flat();
            this.showError(errorMessages.join('<br>'));
            return;
        }

        // Check for success
        if (data.success) {
            this.showSuccess(
                '<strong>Vielen Dank für Ihre Anmeldung!</strong>' +
                'Sie erhalten in Kürze eine E-Mail mit einem Bestätigungslink. ' +
                'Bitte klicken Sie auf den Link in der E-Mail, um Ihre Newsletter-Anmeldung abzuschließen.'
            );
            this.form.reset();
        } else {
            this.showError('Es gab einen Fehler bei der Anmeldung. Bitte versuchen Sie es später erneut.');
        }
    }

    handleError(error) {
        console.error('Newsletter form error:', error);
        this.setLoadingState(false);
        this.showError('Es gab einen technischen Fehler. Bitte versuchen Sie es später erneut.');
    }

    showSuccess(message) {
        // Hide the form fields and button bar
        if (this.formFieldsWrapper) {
            this.formFieldsWrapper.style.display = 'none';
        }

        // Show success message
        this.messageContainer.innerHTML = `<div class="newsletter-success success">${message}</div>`;
        this.messageContainer.classList.remove('hidden');

        // Scroll to message
        this.messageContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    showError(message) {
        // Make sure form is visible when showing errors
        if (this.formFieldsWrapper) {
            this.formFieldsWrapper.style.display = 'block';
        }

        this.messageContainer.innerHTML = `<div class="errors">${message}</div>`;
        this.messageContainer.classList.remove('hidden');

        // Scroll to message
        this.messageContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    clearMessages() {
        this.messageContainer.innerHTML = '';
        this.messageContainer.classList.add('hidden');
    }

    setLoadingState(isLoading) {
        if (isLoading) {
            this.submitButton.disabled = true;
            this.submitButton.textContent = 'Wird gesendet...';
            this.submitButton.classList.add('loading');
        } else {
            this.submitButton.disabled = false;
            this.submitButton.textContent = this.originalButtonText;
            this.submitButton.classList.remove('loading');
        }
    }

    showForm() {
        if (this.formFieldsWrapper) {
            this.formFieldsWrapper.style.display = 'block';
        }
    }

    isValidEmail(email) {
        // Regular expression for email validation
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return emailRegex.test(email);
    }
}
